import {
    Stepper,
    Step,
    StepLabel,
    stepLabelClasses,
    stepIconClasses,
    StepConnector,
    stepConnectorClasses,
    styled,
    Box,
} from '@mui/material'
import {
    CreateCompanyStep,
    useCreateCompanyContext,
} from '../CreateCompanyContext'

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 25,
        left: 'calc(-50% + 26px)',
        right: 'calc(50% + 26px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: theme.palette.info.main,
            color: 'red',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: theme.palette.info.main,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: '#fff',
        borderRadius: 1,
    },
}))

function FormStepper() {
    const { step } = useCreateCompanyContext()

    const stepArr = Object.values(CreateCompanyStep)
        .filter((value) => typeof value === 'string')
        .slice(0, -1)

    return (
        <Box maxHeight={110}>
            <Stepper
                activeStep={step}
                alternativeLabel
                connector={<CustomStepConnector />}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: 'inherit',
                    width: '100%',
                }}
            >
                {stepArr.map((label) => {
                    return (
                        <Step key={label} color="info">
                            <StepLabel
                                sx={{
                                    [`& ${stepLabelClasses.active}`]: {
                                        color: (theme) =>
                                            theme.palette.info.main,
                                    },
                                    [`& ${stepLabelClasses.completed}`]: {
                                        color: (theme) =>
                                            theme.palette.info.main,
                                    },
                                    [`& ${stepLabelClasses.label}`]: {
                                        color: '#fff',
                                    },
                                }}
                                StepIconProps={{
                                    sx: {
                                        zIndex: 1,
                                        width: 55,
                                        height: 55,
                                        borderRadius: '50%',
                                        border: 'solid 1px #fff',
                                        color: (t) => t.palette.primary.light,
                                        [`&.${stepIconClasses.active}`]: {
                                            color: (theme) =>
                                                theme.palette.info.main,
                                            border: (theme) =>
                                                'solid 1px ' +
                                                theme.palette.info.main,
                                        },
                                        [`&.${stepIconClasses.completed}`]: {
                                            color: (theme) =>
                                                theme.palette.info.main,
                                            border: (theme) =>
                                                'solid 1px ' +
                                                theme.palette.info.main,
                                        },
                                    },
                                }}
                            ></StepLabel>
                        </Step>
                    )
                })}
            </Stepper>
        </Box>
    )
}

export default FormStepper
